module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"structureTitle":"Vibration monitoring tool","structureSubTitle":"Select a Vibrometer sensor to analyze its data."},"it":{"structureTitle":"Tool per il monitoraggio vibrazionale","structureSubTitle":"Seleziona un sensore vibrometro di cui analizzare i dati."}}')
  delete Component.options._Ctor
}
